<div class="container">
  <p>&nbsp;</p>
  <b-overlay :show="isLoading" rounded="sm">
    <div class="col-md-12" v-if="!AllowPayment">
      <div class="col-md-6 col-md-offset-4">
        <div class="alert alert-info"> <i class="fa fa-info-circle" aria-hidden="true"></i> Umbai Credits Balance is too low
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="col-md-6 col-md-offset-4">
        <div class="panel panel-default">
          <div class="panel-body">

            <div class="text-center">
              <div class="panel-body">

                <div class="form-group">

                  Credits Available {{currency}}: {{balance.toFixed(2)}}
                </div>
                <div class="form-group">
                  Description : {{payment.itemDescription}}
                </div>
                <div class="form-group">
                  Total to Pay {{currency}}: <strong>{{payment.totalAmount.toFixed(2)}}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-footer">
            <div class="col-md-12">
              <div class="col-md-12" v-if="AllowPayment">
                <input type="button" class="btn btn-lg btn-primary btn-block" value="Proceed" @click="makePayment" />
                <br />
              </div>

              <div class="col-md-12">
                <a href="/Checkout">
                  <input type="button" class="btn btn-lg btn-default btn-block" value="Back" />
                </a>
              </div>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</div>
